import { addToCart, redirectToCart } from 'features/cart';
import { formatReferringSortData } from 'features/sort';
import { showAddToCartFailureModal } from 'features/cart/desktop';
import { setButtonStateDuringActivity, resetButtonStateAfterActivity } from 'utilities/dom';
import { utagLinkPDP } from 'features/tealium';
import { Reporter } from 'features/dataCapture';
import { dataCaptureTimeout } from 'ui/config';

// TODO: add data capture
function setTestCompositionId () {

	return window.top.utag_data.testcomposition_id ? window.top.utag_data.testcomposition_id[0] : null;

}

function setSortParams (sortPath, sortPosition, sortSku, listType) {

	let sortParams = formatReferringSortData(sortPath, sortPosition, sortSku, listType);

	// if directly coming to a PDP page then sortParams is not set.
	if (!sortParams) {

		sortParams = {
			SortSku: window.shortSku,
			ListType: window.utag_data.list_type ? window.utag_data.list_type : undefined
		};

	}

	return sortParams;

}

function setProductsDataForAddToCart (recommendedBulbs) {

	return (
		[ ...recommendedBulbs ]
			.map((recommendedBulb) => {

				const {
					sku, name, price, category, brand, style, skuInputType
				} = recommendedBulb.dataset;
				const quantity = parseInt(recommendedBulb.value, 10);

				return {
					ShortSku: sku,
					Quantity: quantity,
					Name: name,
					Price: price,
					Category: category,
					Brand: brand,
					Style: style,
					TestCompositionId: setTestCompositionId(),
					SkuInputType: skuInputType
				};

			})
			// filter out skus with 0 quantity
			.filter((d) => Boolean(d.Quantity))
	);

}

function addRecommendedBulbToCart (qtyInputs, addToCartBtn, sortPath, sortPosition, sortSku, listType) {

	// get ready to send data to add to cart API
	const arrData = setProductsDataForAddToCart(qtyInputs);
	// display error message if total quantity of recommended bulbs is < 1
	if (arrData.length === 0) {

		showAddToCartFailureModal({
			cartStatus: [ 'Please enter a quantity for one or more products.' ]
		});
		return;

	}
	const waitForDataCaptureAndRedirectToCart = (addToCartRecordId) => {

		if (!window.lp.globals.enableDataCapture) {

			redirectToCart();
			return;

		}

		const { reporter } = window.lp.dataCapture;
		const dataCapturePromises = [];
		arrData.forEach((bulb) => {

			const itemImg = document.querySelector(
				`[data-capture-section="RecommendedBulbsPDP"] img[data-sku="${bulb.ShortSku}"]`
			);

			const skuViewRecord = reporter.getRecordByElement(itemImg);
			const skuViewRequest = skuViewRecord
				? skuViewRecord.promise
				: reporter.track(Reporter.getSkuViewData(itemImg));
			dataCapturePromises.push(skuViewRequest);

		});

		const atcRecord = reporter.getRecordById(addToCartRecordId);
		const atcRequest = atcRecord.promise;
		dataCapturePromises.push(atcRequest);
		const timeout = window.setTimeout(redirectToCart, dataCaptureTimeout);
		Promise.all(dataCapturePromises).finally(() => {

			window.clearTimeout(timeout);
			redirectToCart();

		});

	};
	setButtonStateDuringActivity(addToCartBtn);
	const addToCartRecordId = trackAddToCart(arrData, addToCartBtn);
	utagLinkPDP()({
		eventAction: 'Click-Recommended-Bulb-Add-To-Cart',
		eventLabel: `${window.location.pathname}-${arrData.map((p) => p.ShortSku).join(',')}`
	});
	addToCart({
		arrData,
		successCallback: () => {

			waitForDataCaptureAndRedirectToCart(addToCartRecordId);

		},
		errorCallback: (errors, xhr, response) => {

			showAddToCartFailureModal({
				cartStatus: errors,
				response,
				fromModal: false
			});
			resetButtonStateAfterActivity(addToCartBtn);

		},
		includeCartOverview: false,
		rememberLastAddedItem: false,
		sortParams: setSortParams(sortPath, sortPosition, sortSku, listType)
	});

}
function trackAddToCart (data, addToCartBtn) {

	if (!window.lp.globals.enableDataCapture) {

		return;

	}

	const { reporter } = window.lp.dataCapture;

	reporter.trackAddToCart(data, addToCartBtn);
	return reporter.getLastRecordId();

}
function validateQuantity (qtyElement, recommendedBulbTypeCount) {

	const qty = qtyElement.value.trim();
	const { sku, recommendedQty } = qtyElement.dataset;

	// track quantity update
	// do not trigger if qty is same as recommended
	if (qty !== '' && Number(qty) !== Number(recommendedQty)) {

		utagLinkPDP()({
			eventAction: 'Update-Recommended-Bulb-Qty',
			eventLabel: `${window.location.pathname}-${sku}`
		});

	}

	// reset to default recommended quantity
	// for products with more than 1 bulb type reset only if no quantity provided
	// for products with only 1 bulb type reset if no quantity provided or quantity is 0
	if ((recommendedBulbTypeCount === 1 && (Number(qty) === 0 || qty === '')) || qty === '') {

		// eslint-disable-next-line no-param-reassign
		qtyElement.value = recommendedQty || '1';

	}

}

function initRecommendedBulbs (recommendedBulbTypeCount, sortPath, sortPosition, sortSku, listType) {

	const qtyInputs = document.querySelectorAll('.pdRecommendedBulb__qty input');
	const recBulbsAddToCartBtn = document.getElementById('pdRecommendedBulbAddToCart');

	if (!recBulbsAddToCartBtn || qtyInputs.length === 0) {

		return;

	}

	$(qtyInputs).inputFilter({
		type: 'integer'
	});

	qtyInputs.forEach((qtyInput) => {

		qtyInput.addEventListener('blur', (e) => validateQuantity(e.currentTarget, recommendedBulbTypeCount));
		qtyInput.addEventListener('keypress', (e) => {

			if (e.which === 13) {

				e.preventDefault();
				validateQuantity(e.currentTarget);
				recBulbsAddToCartBtn.click();

			}

		});

	});

	recBulbsAddToCartBtn.addEventListener('click', () => {

		addRecommendedBulbToCart(qtyInputs, recBulbsAddToCartBtn, sortPath, sortPosition, sortSku, listType);

	});

	utagLinkPDP()({
		eventAction: 'Load-Recommended-Bulb',
		eventLabel: window.location.pathname,
		nonInteraction: 1
	});

}

export default initRecommendedBulbs;
